import { render } from "./GridCardsApontamentosAbertos.vue?vue&type=template&id=f55d0848&scoped=true"
import script from "./GridCardsApontamentosAbertos.vue?vue&type=script&lang=js"
export * from "./GridCardsApontamentosAbertos.vue?vue&type=script&lang=js"

import "./GridCardsApontamentosAbertos.vue?vue&type=style&index=0&id=f55d0848&scoped=true&lang=css"

import exportComponent from "X:\\GRV\\CPS5\\Projetos\\CPSDashApontamento\\apontamentowebvueV3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f55d0848"]])

export default __exports__